// ============================================================================
// src/layer/layerRoutes.ts — the layer domain's route table.
// ============================================================================
// B3.1 finish, third domain. Same shape as the cattle and sheep tables, and
// the first one where a row carries TWO paths.
//
// `layerbatches` owns '/layer/housings/*' as well as its own
// '/layer/batches/*': the URL→view adapter in App maps both prefixes back to
// the same view, because LayerBatchesRouter renders the housings record page
// too. That is the whole reason a row's paths are a list rather than a single
// string -- '/layer/housings' is not reachable from '/layer/batches' by any
// prefix rule, so a one-path row would have sent a housings record page back
// to the batches hub with its id dropped.
//
// paths[0] stays the canonical path, the one the URL↔view effect navigates to
// and the one a transition frame falls back to.
//
//   /layer/batches/<id>   LayerBatchesRouter — batch record page
//   /layer/housings/<id>  LayerBatchesRouter — housing record page
//   /layer/dailys/<id>    LayerDailysView — daily record page
//   /layer/eggs/<id>      EggDailysView — egg daily record page
//
// '/layer' and '/layer/groups' are exact and must stay exact.
// ============================================================================

export const LAYER_ROUTES = [
  {view: 'layersHome', paths: ['/layer']},
  {view: 'layers', paths: ['/layer/groups']},
  {view: 'layerbatches', paths: ['/layer/batches/*', '/layer/housings/*']},
  {view: 'layerdailys', paths: ['/layer/dailys/*']},
  {view: 'eggdailys', paths: ['/layer/eggs/*']},
];
